module.exports = __webpack_public_path__ + "img/Banner_Linksunten.224958e0.webp";